import { iUploadeImagesList } from './imageUpload';

/* 查询 */
export interface iHotGameSearch {
  act_free?: number;
  title?: string;
  game_name?: string;
  page: number;
  size: number;
  game_type_id?: number;
  kind_id?: number;
  endpoint?: number;
}
/* 查询类型选择 */
export interface iSelectValueString {
  label: string;
  value: number;
}

/* 详情 */
export interface iHotGameDetails {
  id: number;
  top_title: string;
  sub_title: string;
  game_id: number;
  act_free: boolean; //是否免账号
  in_screen: boolean; //是否通屏
  remark: string;
  game_name?: string;
  enter_img: string;
  enter_img2?: string;
  main_img: string;
  sort?: number;
  version?: number;
  game_media: iUploadeImagesList[];
  endpoint: number;
  kind_id?: number;
}

/* 排序 升序(up)还是降序(down),大小写不敏感*/
export interface iSort {
  id: number;
  sort: string;
  version: number;
}

/* 热门游戏 */
export interface iHotTypeGameSearch {
  // page: number;
  // size: number;
  endpoint: number;
  search: string;
}

export interface iHotTypeGame {
  id: number;
  title: string;
  endpoint: number;
  version?: number;
  index_category?: number;
}

export interface iHotGameTypeSort {
  id: number;
  sort: string;
  version: number;
}

export enum eEndPoint {
  /**ADNROID 1 */
  ADNROID = 1,
  /** WEB 2*/
  WEB = 2,
  /** PC 3*/
  PC = 3,
  /** IOS 5*/
  IOS = 5,
  /** NO 0
   */
  NO = 0,
}
